module.exports = __webpack_public_path__ + "static/assets/79c581ceac035de224617eb630d61322.png";